<template>
  <nav class="dashboard_menu">
    <div class="nav nav-tabs" role="tablist">
      <router-link
          :to="{ name: 'dashboardAdminInfo'}"
          :class="{ active: $route.name === 'dashboardAdminInfo' }"
          class="nav-item nav-link" role="tab">
        {{ $t('dashboard.tabs.info') }}
      </router-link>
      <router-link
          :to="{ name: 'dashboardAdminChartOverview' }"
          :class="{ active: $route.name === 'dashboardAdminChartOverview' }"
          class="nav-item nav-link" role="tab">
        {{ $t('dashboard.tabs.overviews') }}
      </router-link>
      <router-link
          :to="{ name: 'dashboardAdminPotentialUnits' }"
          :class="{ active: $route.name === 'dashboardAdminPotentialUnits' }"
          class="nav-item nav-link" role="tab">
        {{ $t('dashboard.tabs.preview_units_locations') }}
      </router-link>
    </div>
  </nav>
</template>

<script setup>
import { RouterLink } from 'vue-router';
</script>

<style scoped>

</style>